module.exports = __webpack_public_path__ + "static/media/image-1.0211b706.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/depto-64/image-1.jpg
// module id = 263
// module chunks = 0